import { withSvgIconSimple } from './withSvgIconSimple';

export const Unfreeze = withSvgIconSimple(
  <>
    <path
      d="M2 18L5 20H19L22 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M8 4L6 8L8 12L6 17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M13 4L11 8L13 12L11 17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M18 4L16 8.00001L18 12L16 17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
